import { render, staticRenderFns } from "./DataCorrectionDetails.vue?vue&type=template&id=557f4c34&scoped=true&"
import script from "./DataCorrectionDetails.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionDetails.vue?vue&type=style&index=0&id=557f4c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f4c34",
  null
  
)

export default component.exports